import React from "react";
import {
  Row,
  Input,
  Button,
  Table,
  Form,
  Tag,
  Icon,
  Pagination,
  Skeleton,
  Spin,
  Tooltip,
} from "antd";
import { withTranslation } from "react-i18next";
import { Link, withRouter } from "react-router-dom";
import { saveLastListUrl } from "../../utils/navOrigin";
import { ReactComponent as PODIcon } from "../../../public/images/signature.svg";
import { formatDate } from "../../utils/dateUtils";
import CSVIconComponent from "../Icons/CSVIconComponent";
import XLSIconComponent from "../Icons/XLSIconComponent";
import { ReactComponent as PDF } from "../../../public/images/viewPdf.svg";
import { connect } from "react-redux";
import {
  setSearchParameters,
  setHomePagination,
} from "../../redux/slices/homeSearchSlice";
import TelemetryVariantSwitch from "../TelemetryVariantSwitch/TelemetryVariantSwitch";
import {
  normalizeVariant,
  getShipmentWarningsByVariant,
  compareShipmentWarningsByVariant,
  SHIPMENT_WARNING_KIND,
} from "../../utils/shipmentsTransformers";
import {
  stringSorter,
  numberSorter,
  dateSorter,
  normalizeString,
} from "../../utils/sortUtils";

const EditableContext = React.createContext();
const events = ["Preadmisión", "En camino", "En entrega", "Entregado"];
let self;

let green = "#3f8600";
let red = "#ca0909";

class DetailedTracksTable extends React.Component {
  constructor(props) {
    super(props);

    const { startValue, endValue, onDateRangePicked } =
      this.props.searchParameters;
    this.state = {
      message: "Cargando...",
      statusCode: 0,
      dataSource: [],
      count: 0,
      searchText: "",
      searchedColumn: "",
      editingKey: "",
      showDeleteModal: false,
      dataToShow: [],
      currentPage: props.currentPage || 1,
      status: "loading",
      startValue: startValue,
      endValue: endValue,
      size: props.pageSize || 10,
      paginatedSearch: false,
      mustShowTable: false,
      telemetryVariant: "full",
    };

    self = this;
  }

  eventNameColor(param, date) {
    let color;
    switch (param) {
      case "Preadmisión":
        color = "red";
        break;
      case "En camino":
        color = "blue";
        break;
      case "En entrega":
        color = "cyan";
        break;
      case "Entregado":
        color = "green";
        break;
      default:
        color = "volcano";
        break;
    }
    color = "blue";
    let txt = param;

    if (param) {
      let arrayDeCadenas = param.split(":");
      txt = arrayDeCadenas[0];
    }

    return (
      <Tag color={color} key={param}>
        <span style={{ whiteSpace: "pre-wrap" }}>{txt}</span>
      </Tag>
    );
  }

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 190, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Buscar
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reiniciar
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      normalizeString(record?.[dataIndex]).includes(normalizeString(value)),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
  });

  handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  }

  handleReset(clearFilters) {
    clearFilters();
    this.setState({
      searchText: "",
    });
  }

  handlePagChange(page, size) {
    let { dataToShow } = self.state;

    self.props.setHomePagination({ page, size });
    self.setState({
      dataToShow,
      currentPage: page,
      size,
      paginatedSearch: true,
      status: "paginating",
    });
  }

  handlePagSizeChange(current, size) {
    if (self.props.shipmentData.totalResults === self.state.dataSource.length) {
      if (size > self.state.dataSource.length) {
        return false;
      }
    }

    self.props.setHomePagination({ page: 1, size });
    self.setState({
      size,
      currentPage: 1,
      paginatedSearch: true,
      status: "paginating",
    });
  }

  handleVariantChange = (variant) => {
    this.setState({ telemetryVariant: variant });
  };

  getTelemetryVariant = () => normalizeVariant(this.state.telemetryVariant);

  renderYesNoAlert = (count) => {
    const alertMessage = count > 0 ? "Sí" : "No";
    const alertColor = count > 0 ? red : green;
    return <span style={{ color: alertColor }}>{alertMessage}</span>;
  };

  renderAlertsCell = (record, kind) => {
    const n = getShipmentWarningsByVariant(
      record,
      this.getTelemetryVariant(),
      kind,
    );
    return this.renderYesNoAlert(n);
  };

  makeWarningsSorter = (kind) => (a, b) =>
    compareShipmentWarningsByVariant(a, b, this.getTelemetryVariant(), kind);

  renderMacData = (mac) => {
    if (mac && mac !== "N/D") {
      return (
        <>
          <br />
          <span className="mac-muted">({mac})</span>
        </>
      );
    }
    return null;
  };

  handleSearchOrders(searchParameters) {
    const {
      shipmentCode,
      imei,
      numRefClient,
      onDateRangePicked,
      onParameterPicked,
      startValue,
      endValue,
      clientNumber,
      labellerCode,
      boxType,
      temperatureTrazability,
      temperatureRange,
    } = searchParameters;

    if (onDateRangePicked || onParameterPicked) {
      const defaultCurrentPage = 1;

      this.props.fetchShipments(
        shipmentCode,
        imei,
        numRefClient,
        startValue,
        endValue,
        clientNumber,
        labellerCode,
        boxType,
        temperatureTrazability,
        temperatureRange,
        this.state.size,
        defaultCurrentPage,
      );

      this.props.setSearchParameters({
        onDateRangePicked: false,
        onParameterPicked: false,
      });
      this.setState({ currentPage: defaultCurrentPage });
    }
  }

  handlePagination(searchParameters, tableParameters) {
    const {
      shipmentCode,
      imei,
      numRefClient,
      startValue,
      endValue,
      clientNumber,
      labellerCode,
      boxType,
      temperatureTrazability,
      temperatureRange,
    } = searchParameters;
    const { size, currentPage, paginatedSearch } = tableParameters;

    if (paginatedSearch) {
      this.props.fetchShipments(
        shipmentCode,
        imei,
        numRefClient,
        startValue,
        endValue,
        clientNumber,
        labellerCode,
        boxType,
        temperatureTrazability,
        temperatureRange,
        size,
        currentPage,
        paginatedSearch,
      );

      this.setState({
        paginatedSearch: false,
      });
    }
  }

  setValues(check, telemetryTypeCode) {
    let iconType, color, message;

    switch (check) {
      case 0:
        iconType = "warning";
        color = "#f5d033";
        message = "No Gestionado";
        break;
      case 1:
        iconType = "check-circle";
        color = "#52C41A";
        if (telemetryTypeCode === 3) {
          message = "Offline (PDF)";
        } else if (telemetryTypeCode === 4) {
          message = "Online";
        } else if (telemetryTypeCode === 5) {
          message = "Offline (Datos)";
        }
        break;
      case 2:
        iconType = "close-circle";
        color = "#DB1010";
        if (telemetryTypeCode === 1) {
          message = "Sin Grabación";
        } else if (telemetryTypeCode === 2) {
          message = "Sin Datalogger";
        }
        break;
      case 3:
        iconType = "warning";
        color = "#0066ff";
        message = "Online (Envío sin Admisión)";
        break;
      default:
        iconType = "warning";
        color = "#f5d033";
        message = "No Gestionado";
        break;
    }

    return { iconType, color, message };
  }

  handleExport = (fileType) => {
    if (this.props.onExport) {
      this.props.onExport(fileType, this.state.telemetryVariant);
    }
  };

  componentDidMount() {
    const { shipmentData } = this.props;

    const hasResults =
      shipmentData &&
      shipmentData.status === "loaded" &&
      shipmentData.statusCode === 200 &&
      Array.isArray(shipmentData.data) &&
      shipmentData.data.length > 0;

    if (hasResults) {
      this.setState({
        dataSource: shipmentData.data,
        dataToShow: shipmentData.data,
        count: shipmentData.totalResults,
        status: shipmentData.status,
        statusCode: shipmentData.statusCode,
        currentPage: this.props.currentPage || shipmentData.page || 1,
        size: this.props.pageSize || shipmentData.size || this.state.size,
        mustShowTable: true,
      });
    } else if (
      this.props.searchParameters.onDateRangePicked ||
      this.props.searchParameters.onParameterPicked
    ) {
      this.handleSearchOrders(this.props.searchParameters, this.state.size);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.searchParameters.onDateRangePicked ||
      this.props.searchParameters.onParameterPicked
    ) {
      this.handleSearchOrders(
        this.props.searchParameters,
        this.state.size,
        this.state.paginatedSearch,
      );
    }

    if (this.state.paginatedSearch) {
      this.handlePagination(this.props.searchParameters, this.state);
    }

    if (prevProps.shipmentData !== this.props.shipmentData) {
      if (
        this.props.shipmentData.statusCode === 0 &&
        this.props.shipmentData.status === "paginating"
      ) {
        this.setState({
          mustShowTable: true,
          status: "paginating",
        });
        return false;
      }

      if (this.props.shipmentData.statusCode !== 200) {
        this.setState({
          message: this.props.shipmentData.message,
          status: this.props.shipmentData.status,
          statusCode: this.props.shipmentData.statusCode,
          mustShowTable: false,
        });
        return false;
      }

      if (this.props.shipmentData.statusCode === 200) {
        if (
          !this.props.shipmentData.data.length &&
          this.props.shipmentData.status === "loaded"
        ) {
          this.setState({
            statusCode: 204,
            status: "loaded",
            message: "No se han encontrado datos.",
            mustShowTable: false,
          });
          return false;
        }

        this.setState({
          dataSource: this.props.shipmentData.data,
          count: this.props.shipmentData.totalResults,
          dataToShow: this.props.shipmentData.data,
          status: this.props.shipmentData.status,
          statusCode: this.props.shipmentData.statusCode,
          currentPage: this.props.currentPage || this.props.shipmentData.page,
          size:
            this.props.pageSize ||
            this.props.shipmentData.size ||
            this.state.size,
          mustShowTable: true,
        });
      }
    }
  }

  render() {
    const {
      dataToShow,
      count,
      currentPage,
      size,
      status,
      statusCode,
      message,
      mustShowTable,
    } = this.state;
    const components = {
      body: {
        //cell: withTranslation()(EditableCell),
      },
    };

    const from = this.props.location.pathname + this.props.location.search;

    const tableColumns = [
      {
        title: "Código de bulto",
        dataIndex: "shipmentCode",
        sorter: stringSorter("shipmentCode"),
        sortDirections: ["descend", "ascend"],
        editable: false,
        width: 90,
        align: "center",
        ...this.getColumnSearchProps("shipmentCode"),
        render: (shipmentCode) => (
          <span>
            <Link
              to={{
                pathname: "/envio",
                search: `?shipmentCode=${shipmentCode}`,
                state: { from },
              }}
              onClick={() => saveLastListUrl(from)}
            >
              {shipmentCode}
            </Link>
          </span>
        ),
      },
      {
        title: "IMEI (MAC)",
        dataIndex: "imei",
        sorter: stringSorter("imei"),
        sortDirections: ["descend", "ascend"],
        editable: false,
        width: 90,
        align: "center",
        ...this.getColumnSearchProps("imei"),
        render: (imei, record) => (
          <>
            <span>{imei}</span>
            {this.renderMacData(record.macMando)}
          </>
        ),
      },
      {
        title: "Ref. cliente / pedido",
        dataIndex: "numRefClient",
        sorter: stringSorter("numRefClient"),
        sortDirections: ["descend", "ascend"],
        editable: false,
        width: 75,
        align: "center",
        ...this.getColumnSearchProps("numRefClient"),
      },
      {
        title: "Datos",
        dataIndex: "check",
        editable: false,
        width: 55,
        align: "center",
        sorter: numberSorter("check"),
        sortDirections: ["descend", "ascend"],
        render: (check, record) => {
          const { iconType, color, message } = this.setValues(
            check,
            record.telemetryTypeCode,
          );
          return (
            <span style={{ color: color, fontSize: "1.5rem" }}>
              <Tooltip title={message}>
                <Icon type={iconType} />
              </Tooltip>
            </span>
          );
        },
      },
      {
        title: "Alertas (Temp)",
        dataIndex: "warningsTempTotal",
        width: 60,
        align: "center",
        sorter: this.makeWarningsSorter(SHIPMENT_WARNING_KIND.TEMP),
        sortDirections: ["descend", "ascend"],
        render: (_, record) =>
          this.renderAlertsCell(record, SHIPMENT_WARNING_KIND.TEMP),
      },
      {
        title: "Alertas (Impacto)",
        dataIndex: "warningsImpactTotal",
        width: 70,
        align: "center",
        sorter: this.makeWarningsSorter(SHIPMENT_WARNING_KIND.IMPACT),
        sortDirections: ["descend", "ascend"],
        render: (_, record) =>
          this.renderAlertsCell(record, SHIPMENT_WARNING_KIND.IMPACT),
      },
      {
        title: "Alertas (Apertura)",
        dataIndex: "warningsOpenTotal",
        width: 70,
        align: "center",
        sorter: this.makeWarningsSorter(SHIPMENT_WARNING_KIND.OPEN),
        sortDirections: ["descend", "ascend"],
        render: (_, record) =>
          this.renderAlertsCell(record, SHIPMENT_WARNING_KIND.OPEN),
      },
      {
        title: "Remitente",
        dataIndex: "senderName",
        sorter: stringSorter("senderName"),
        sortDirections: ["descend", "ascend"],
        editable: false,
        width: 90,
        align: "center",
        ...this.getColumnSearchProps("senderName"),
      },
      {
        title: "Último evento",
        dataIndex: "eventName",
        sorter: stringSorter("eventName"),
        sortDirections: ["descend", "ascend"],
        editable: false,
        width: 80,
        align: "center",
        render: (eventName) => (
          <div className="cell-event-box">{!eventName ? "N/D" : eventName}</div>
        ),
      },
      {
        title: "Fecha y hora",
        dataIndex: "eventDate",
        sorter: dateSorter("eventDate"),
        sortDirections: ["descend", "ascend"],
        editable: false,
        width: 60,
        align: "center",
        render: (_, record) => {
          return <span>{formatDate(record.eventDate)}</span>;
        },
      },
      {
        title: "Destinatario",
        dataIndex: "destinationName",
        sorter: stringSorter("destinationName"),
        sortDirections: ["descend", "ascend"],
        editable: false,
        width: 90,
        align: "center",
        ...this.getColumnSearchProps("destinationName"),
      },
      {
        title: "Fecha alta en plataforma",
        dataIndex: "startDate",
        sorter: dateSorter("startDate"),
        sortDirections: ["descend", "ascend"],
        editable: false,
        width: 75,
        align: "center",
        render: (_, record) => {
          return <span>{formatDate(record.startDate)}</span>;
        },
      },
      {
        title: "Acciones",
        dataIndex: "actions",
        width: 55,
        align: "center",
        render: (_, record) => {
          const { shipmentCode, eventName } = record;
          const disabled = eventName !== "Entregado";

          return (
            <div className="actions-cell">
              <Tooltip title="POD / Sello">
                <span>
                  <PODIcon
                    onClick={() =>
                      !disabled && this.props.fetchShipmentPod(shipmentCode)
                    }
                    className={disabled ? "icon-disabled" : "icon-active"}
                  />
                </span>
              </Tooltip>

              <Tooltip title="Etiqueta">
                <span>
                  <PDF
                    onClick={() =>
                      this.props.onOpenLabelModal(record.shipmentCode)
                    }
                    className="icon-active"
                    style={{ width: "1em", height: "1em" }}
                  />
                </span>
              </Tooltip>
            </div>
          );
        },
      },
    ];

    const columns = tableColumns.map((col) => {
      return col;
    });

    const pagProps = {
      total: count,
      showSizeChanger: true,
      showQuickJumper: true,
      showTotal: (total) => `${total} resultados`,
      hideOnSinglePage: false,
      current: this.props.currentPage || self.state.currentPage,
      pageSize: this.props.pageSize || size,
      pageSizeOptions: ["10", "20", "40", "80"],
    };

    const paginationProps = {
      bordered: true,
      rowClassName: () => "editable-row",
    };

    return (
      <div className="Envios">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "1rem",
          }}
        >
          <h2 style={{ margin: 0, lineHeight: 1 }}>
            {this.props.t("common.trackingsList")}
          </h2>

          {mustShowTable && (
            <div
              style={{ display: "flex", alignItems: "center", gap: "1rem" }}
              className="tracks-table-scroll"
            >
              <TelemetryVariantSwitch
                variant={this.state.telemetryVariant}
                onChange={this.handleVariantChange}
              />

              <Button
                type="default"
                onClick={() => this.handleExport("csv")}
                className="export-btn"
                disabled={status !== "loaded"}
              >
                <CSVIconComponent />
                Exportar CSV
              </Button>

              <Button
                type="default"
                onClick={() => this.handleExport("excel")}
                className="export-btn"
                disabled={status !== "loaded"}
              >
                <XLSIconComponent />
                Exportar Excel
              </Button>
            </div>
          )}
        </div>

        {status === "loading" && (
          <>
            <Skeleton active />
          </>
        )}

        {statusCode !== 200 && status === "loaded" && (
          <>
            <p>{message}</p>
          </>
        )}

        {mustShowTable && (
          <EditableContext.Provider value={this.props.form}>
            <Spin
              tip="Cargando..."
              spinning={status === "paginating"}
              size="large"
              style={{ transform: "scale(2)" }}
            >
              <div className="tracks-table-scroll">
                <Table
                  components={components}
                  tableLayout="fixed"
                  {...paginationProps}
                  dataSource={dataToShow}
                  columns={columns}
                  pagination={false}
                />
              </div>
              <Row
                type="flex"
                justify="end"
                style={{ marginTop: 16, background: "none", padding: 0 }}
              >
                <Pagination
                  {...pagProps}
                  onChange={this.handlePagChange}
                  onShowSizeChange={this.handlePagSizeChange}
                  style={{ background: "none" }}
                />
              </Row>
            </Spin>
          </EditableContext.Provider>
        )}
      </div>
    );
  }
}

export default withRouter(
  connect(null, { setSearchParameters, setHomePagination })(
    withTranslation()(Form.create()(DetailedTracksTable)),
  ),
);
